var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"alert"}},_vm._l((_vm.stack),function(alert,index){return _c('div',{key:index},[_c('b-alert',{attrs:{"show":alert.show,"variant":alert.variant,"dismissible":""},on:{"dismissed":function($event){return _vm.clearNotification(alert.id)}}},[_vm._v(_vm._s(alert.message))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }